// extracted by mini-css-extract-plugin
module.exports = {"card":"AddReviewPage_card__2ka7I"};